var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EcomWrapperEventTypeEnumsObj } from "../enums/EcomWrapperEventTypeEnum";
import { EcomWalletSdkEnumsObj } from "../enums/EcomWalletSdkEnum";
import { dispatchEvent } from "./EventHandler";
import { ApplePayEventListenerEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayEventListenerEnum";
import { GooglePayEventListenerEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayEventListenerEnum";
import payairApplePay from "@payair/apple-pay-sdk";
import payairGooglePay from "@payair/google-pay-sdk";
import payairSamsungPay from "@payair/samsung-pay-sdk";
import { SamsungPayEventListenerEnumsObj } from "@payair/samsung-pay-sdk/enums/SamsungPayEventListenerEnum";
import { BUILD_TYPE, SDK_VERSION } from "../models/EcomWrapperVersion";
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import payairSrci from "@payair/srci-sdk";
import { SrciEventListenerEnumsObj } from "@payair/srci-sdk/enums/SrciEventListenerEnum";
const srciSdk = payairSrci.srciSdk;
const applePaySdk = payairApplePay.applePaySdk;
const googlePaySdk = payairGooglePay.googlePaySdk;
const samsungPaySdk = payairSamsungPay.samsungPaySdk;
/** @internal */
export class EcomWrapperSdkImpl {
    constructor() {
        this.initSdk = (ecomWalletSdkEnum, initParams) => {
            switch (ecomWalletSdkEnum) {
                case EcomWalletSdkEnumsObj.PAYAIR_APPLE_PAY_SDK:
                    window.addEventListener(ApplePayEventListenerEnumsObj.PAYAIR_APPLE_PAY_SDK_LISTENER, onEcomWalletListenerEvent);
                    applePaySdk.initSdk(initParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK:
                    window.addEventListener(GooglePayEventListenerEnumsObj.PAYAIR_GOOGLE_PAY_SDK_LISTENER, onEcomWalletListenerEvent);
                    googlePaySdk.initSdk(initParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK:
                    window.addEventListener(SamsungPayEventListenerEnumsObj.PAYAIR_SAMSUNG_PAY_SDK_LISTENER, onEcomWalletListenerEvent);
                    samsungPaySdk.initSdk(initParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
                    window.addEventListener(SrciEventListenerEnumsObj.PAYAIR_SRCI_SDK_LISTENER, onEcomWalletListenerEvent);
                    srciSdk.initSdk(initParams);
                    break;
                default:
                    dispatchEvent(EcomWrapperEventTypeEnumsObj.WRONG_ECOM_SDK_ENUM_VALUE, ecomWalletSdkEnum);
                    break;
            }
        };
        this.renderButton = (ecomWalletSdkEnum, container, buttonParams) => {
            switch (ecomWalletSdkEnum) {
                case EcomWalletSdkEnumsObj.PAYAIR_APPLE_PAY_SDK:
                    applePaySdk.renderButton(container, buttonParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK:
                    googlePaySdk.renderButton(container, buttonParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK:
                    samsungPaySdk.renderButton(container, buttonParams);
                    break;
                case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
                    srciSdk.renderButton(container, buttonParams);
                    break;
                default:
                    dispatchEvent(EcomWrapperEventTypeEnumsObj.WRONG_ECOM_SDK_ENUM_VALUE, ecomWalletSdkEnum);
                    break;
            }
        };
        this.isReadyToPay = (isReadyToPayParams) => __awaiter(this, void 0, void 0, function* () {
            switch (isReadyToPayParams.ecomWalletSdkEnum) {
                case EcomWalletSdkEnumsObj.PAYAIR_APPLE_PAY_SDK:
                    return yield applePaySdk.isReadyToPay();
                case EcomWalletSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK:
                    return yield googlePaySdk.isReadyToPay(isReadyToPayParams.params);
                case EcomWalletSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK:
                    return yield samsungPaySdk.isReadyToPay(isReadyToPayParams.params);
                case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
                    return yield srciSdk.isReadyToPay();
                default:
                    return Promise.resolve(false);
            }
        });
        this.isUserEligibleToMakePayment = (isReadyToPayParams) => __awaiter(this, void 0, void 0, function* () {
            switch (isReadyToPayParams.ecomWalletSdkEnum) {
                case EcomWalletSdkEnumsObj.PAYAIR_APPLE_PAY_SDK:
                    const params = isReadyToPayParams.merchantId ? isReadyToPayParams.merchantId : "";
                    return yield applePaySdk.isUserEligibleToMakePayment(params);
                case EcomWalletSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK:
                    return yield googlePaySdk.isUserEligibleToMakePayment(isReadyToPayParams.params);
                case EcomWalletSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK:
                    return yield samsungPaySdk.isUserEligibleToMakePayment();
                case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
                    return yield srciSdk.isUserEligibleToMakePayment();
                default:
                    return Promise.resolve(false);
            }
        });
        this.getReadyToPayWallets = (isReadyToPayParamsArray) => __awaiter(this, void 0, void 0, function* () {
            return Promise.allSettled(
            // map all SDK names into array of promises containing
            // SDK name and result of isReadyToPay call
            isReadyToPayParamsArray.map((isReadyToPayParams) => {
                return ((isReadyToPayParams) => __awaiter(this, void 0, void 0, function* () {
                    const result = yield this.isReadyToPay(isReadyToPayParams);
                    return yield Promise.resolve({ type: isReadyToPayParams.ecomWalletSdkEnum, value: result });
                }))(isReadyToPayParams);
            }))
                .then((response) => response //we are getting all settled promises here
                .filter((x) => x.status === "fulfilled") //lets concentrate only on resolved ones
                .map((x) => x["value"]) //get value of resolved promise
                .filter((x) => x.value) //filter only those with value from isReadyToPay as true
                .reduce((prev, current) => {
                //convert objects to expected enums array
                return [...prev].concat(current.type);
            }, []))
                .then((result) => Promise.resolve(result)); //return enum array
        });
        this.getVersion = () => {
            return {
                sdk: BaseEcomSdkEnumsObj.PAYAIR_ECOM_WRAPPER_SDK,
                version: SDK_VERSION,
                buildType: BUILD_TYPE,
                dependencies: [
                    applePaySdk.getVersion(),
                    googlePaySdk.getVersion(),
                    samsungPaySdk.getVersion(),
                    srciSdk.getVersion(),
                ],
            };
        };
    }
    startPayment(ecomWalletSdkEnum, container) {
        let sdk;
        switch (ecomWalletSdkEnum) {
            case EcomWalletSdkEnumsObj.PAYAIR_APPLE_PAY_SDK:
                sdk = applePaySdk;
                break;
            case EcomWalletSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK:
                sdk = googlePaySdk;
                break;
            case EcomWalletSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK:
                sdk = samsungPaySdk;
                break;
            case EcomWalletSdkEnumsObj.PAYAIR_SRCI_SDK:
                sdk = srciSdk;
                break;
            default:
                dispatchEvent(EcomWrapperEventTypeEnumsObj.WRONG_ECOM_SDK_ENUM_VALUE, ecomWalletSdkEnum);
                break;
        }
        if (sdk) {
            sdk.startPayment(container);
            return;
        }
        dispatchEvent(EcomWrapperEventTypeEnumsObj.START_PAYMENT_CALL_FAIL_SDK_NOT_LOADED, ecomWalletSdkEnum);
    }
}
/** @internal */
const onEcomWalletListenerEvent = (event) => {
    const eventDetail = event.detail;
    dispatchEvent(eventDetail);
};
